{
  "deselectedItem": "{item} pole valitud.",
  "select": "Vali",
  "selectedAll": "Kõik üksused valitud.",
  "selectedCount": "{count, plural, =0 {Üksusi pole valitud} one {# üksus valitud} other {# üksust valitud}}.",
  "selectedItem": "{item} valitud."
}
